import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Cache from '@/helper/Cache.js'
/**
 * @method getConsentCurent
 */
export default {
  KEY_COOKIE_USER: 'CRMUser',
  config: function () {
    return Vue.bzbsConfig
  },
  token: function () {
    return Cache.get(this.KEY_COOKIE_USER).Token
  },
  appId: function () {
    return Cache.get(this.KEY_COOKIE_USER).AppId
  },
  agency_id: function () {
    return Vue.$cookies.get(this.KEY_COOKIE_USER).AgencyId
      ? Vue.$cookies.get(this.KEY_COOKIE_USER).AgencyId
      : this.config().agency_id
  },
  getConsentCurent: function (type) {
    var strUrl =
      this.config().bzbsModuleUrl +
      '/consent/current?agencyId=' +
      this.agency_id() +
      '&type=' +
      type
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  getConsentHistory: function (type) {
    var strUrl =
      this.config().bzbsModuleUrl +
      '/consent/histories?agencyId=' +
      this.agency_id() +
      '&type=' +
      type
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
}
